module.exports = __webpack_public_path__ + "img/secondary_1x2_z18.78e32c50.svg";